import Vue from 'vue'
import axios from 'axios'
import config from '@/common/config.js'
import store from '@/store/index.js'
import QS from 'qs'
import md5 from 'js-md5'
import {
	blobValidate
} from "@/common/utils.js";
import {
	saveAs
} from 'file-saver'
import { showLoading, hideLoading } from '@/common/loading';


// create an axios instance
const service = axios.create({
	baseURL: `${config.host}`, // url = base url + request url
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 300000 // request timeout，
})

// request interceptor
service.interceptors.request.use(
	configs => {
		CalcuMD5(QS.parse(configs.data)).then(signMD5 => {
			if (configs.usetoken){
				configs.headers['Authorization'] = localStorage.getItem('token') || ''
			}
		})
		return configs
	},
	error => {
		// do something with request error
		hideLoading()
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		// console.log('response: ',response);
		// 统一定义状态码为200时，表示请求成功，其他请求失败
		if (!response.data.code) {
			return Promise.resolve(response.data)
		}
		let code = response.data.code
		if (code == 200) {
			return Promise.resolve(response.data)
		} else {
			Vue.prototype.$notify.error({
				title: code,
				message: `${response.data.message}`,
			})
			return Promise.reject(response.data)
		}
	},
	error => {
		if (error.response) {
			if (error.response.data) {
				let code = error.response.data.code
				// 登录过期
				if (code == 401) {
					Vue.prototype.$message.warning(error.response.data.message)
					store.commit('changeToken');
					store.commit('changeUInfo');
					return Promise.reject(error.response.data)
				} else {
					Vue.prototype.$notify.error({
						title: code,
						message: error.response.data.message
					})
					return Promise.reject(error.response.data)
				}
			} else {
				Vue.prototype.$notify.error({
					title: error.status,
					message: error.code
				})
				return Promise.reject(error)
			}
		} else {
			Vue.prototype.$notify.error({
				title: error.status,
				message: error.code
			})
			return Promise.reject(error)
		}
	}
)

/**
 * 作者：TKE
 * 时间：2019/12/17 0017
 * 功能：对外接口
 * 描述：
 */

let urls = []

export default function request(options) {
	// 数据处理
	const params = options.sendmsg || {}
	const method = options.method.toUpperCase()
	const url = options.url
	const responseType = options.responseType || 'json'
	const ContentType = options.ContentType || 'application/json;charset=UTF-8'
	const repeat = options.repeat || false
	const usetoken = options.usetoken || false
	//  'application/x-www-form-urlencoded;application/vnd.ms-excel;charset=UTF-8'

	if (!repeat) {
		if (method == 'get') {
			if (Object.keys(params).length) {
				for (let key in params) {
					if (url.indexOf('?') == -1) {
						url = `${url}?${key}=${params[key]}`
					} else {
						url = `${url}&${key}=${params[key]}`
					}
				}
				params = {}
			}
		}
		let index = urls.indexOf(url)
		if (index > -1) {
			return new Promise((resolve, reject) => {
				console.log(`重复请求已被拦截:${url}`);
				reject()
			})
		} else {
			urls.push(url)
		}
	}
	return new Promise((resolve, reject) => {
		begincommin({
			url,
			method,
			params,
			responseType,
			ContentType,
			usetoken
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err);
		}).finally(() => {
			if (!repeat) {
				setTimeout(() => {
					let index = urls.indexOf(url)
					if (index > -1) {
						urls.splice(index, 1)
					}
				}, 200)
			}
		});
	})

}

const begincommin = ({
	url,
	method,
	params,
	responseType,
	ContentType,
	usetoken
}) => {
	return new Promise((resolve, reject) => {
		if (method === 'GET') {
			service({
				url,
				method,
				params,
				responseType,
				usetoken
			}).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		} else if (method === 'POST') {
			// axios.defaults.headers.post['Content-Type'] = ContentType
			const data = params //QS.stringify(params)
			service({
				url,
				method,
				data,
				responseType,
				usetoken,
				headers: {
					"Content-Type": ContentType
				}
			}).then(res => {
				resolve(res)
				let requestLog = {
					code: res.code,
					url,
					method,
					data,
					responseType,
					usetoken,
					res
				}
				// console.log(requestLog);
			}).catch(err => {
				reject(err)
				let requestLog = {
					code: err.code,
					url,
					method,
					data,
					responseType,
					usetoken,
					err
				}
				console.log(requestLog);
			})
		} else if (method === 'PUT' || method === 'PATCH') {
			// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

			const data = QS.stringify(params)
			service({
				url,
				method,
				data,
				responseType,
				usetoken
			}).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		} else if (method === 'DELETE') {
			service({
				url,
				method,
				params,
				responseType,
				usetoken
			}).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		}
	})
}

/**
 * 作者： TKE
 * 时间： 2019/12/17 0017
 * 功能：md5加密请求体
 * 描述：
 */
function CalcuMD5(obj) {
	return new Promise(resolve => {
		// 如果不是对象  也就是说使用的GET和DELETE请求 那么不用加密  直接返回空
		const key = process.env.VUE_APP_AESKEY
		let sign = ''
		// if (Object.prototype.toString.call(obj) !== '[object Object]') {
		// 	sign = key + '--' + key
		// } else {
		// 	if (JSON.stringify(obj) === '{}') {
		// 		sign = key + '--' + key
		// 	} else {
		// 		Object.keys(obj).sort().forEach((k) => {
		// 			sign += key + k + '--' + obj[k] + key
		// 		})
		// 	}
		// }
		resolve(md5(sign).toUpperCase())
	})
}

// 通用下载方法
export function download(url, filename) {
	let downloadLoadingInstance = Vue.prototype.$loading({
		text: "正在下载数据，请稍候",
		spinner: "el-icon-loading",
		background: "rgba(0, 0, 0, 0.7)",
	})
	return service.get(url, {
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		},
		responseType: 'blob'
	}, ).then(async (data) => {
		let flag = await blobValidate(data)
		console.log('flag: ', flag);
		if (flag) {
			// const blob = new Blob([data])
			const blob = new Blob([data])
			saveAs(blob, filename)
			downloadLoadingInstance.close();
		} else {
			const text = await data.text();
			let res = JSON.parse(text);
			Vue.prototype.$notify.error({
				title: `${res.code}`,
				message: `${res.msg}`,
			})
			downloadLoadingInstance.close();
		}
	}).catch((r) => {
		console.error(r)
		downloadLoadingInstance.close();
	})
}